import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import MedicalHistory from "../../components/patient-timeline/medical-history"

const MedicalHistoryContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <MedicalHistory />
      </div>
    </div>
  )
}

export default MedicalHistoryContainer